import { render } from "./PrsPerson.vue?vue&type=template&id=27e3a81c"
import script from "./PrsPerson.vue?vue&type=script&lang=js"
export * from "./PrsPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__